import '../../css/FormTemplate.css';
import '../../css/ToolTip.css';

const FormToolTip = (props:{dataToolTip:string}) => {

    return (
        <span className='tool-tip' 
            data-tooltip={props.dataToolTip}
        >
            <span className='info-icon-span'>
                <img className='info-icon-img' src="/icons/info-icon.png"  alt='info-icon'/>
            </span>
        </span>
    );
};


export default FormToolTip;